import { useEffect, useState } from "react";

const STORAGE_KEY = "shegate_ref_code";
// LIFF URL を直接配布することで iOS Safari/Chrome の Universal Link が発火し、
// LINE アプリへ自動遷移できる (アプリ内なら既ログインで同意画面スキップ)。
// 自社ドメイン (/liff/line-follow) を踏ませると Universal Link が効かず Safari で OAuth login 画面が出てしまう。
const LIFF_ID = "2008555780-gvTo7fwC";

const REF_CODE_PATTERN = /^[A-Za-z0-9]{4,10}$/;

/**
 * 紹介コードがあれば LIFF の URL、なければ既定の URL を返す。フックと、フックが動かない静的な HTML の
 * ボタン (apps/women-lp の冒頭の相談ボタン) の両方が同じ判定を使う
 */
export function resolveLineFollowUrl(defaultUrl: string, refFromUrl: string | null, refFromStorage: string | null): string {
  const code = refFromUrl || refFromStorage;
  if (code && REF_CODE_PATTERN.test(code)) {
    return `https://liff.line.me/${LIFF_ID}?ref=${encodeURIComponent(code)}`;
  }
  return defaultUrl;
}

/**
 * LINE 友だち追加ボタンの遷移先 URL を返す。
 * - URL クエリ or localStorage に紹介コードがあれば LIFF URL に飛ばす
 *   (https://liff.line.me/{LIFF_ID}?ref=XXX → LINE アプリ起動 → /liff/line-follow が LIFF browser で開く)
 *   → LIFF で lineUserId と紹介コードを確定紐付けし、99%+ 精度で referral_conversion を作る
 * - 紹介コードがなければ従来の友だち追加 URL (default は /women/line/t/women-hp-cta)
 *
 * 既定は go.luagate.com/hp だったが、あれは /women/line/t/hp 経由の 302 でしかない。
 * 旧ドメインを1回踏むぶん遅いだけなので、直接そちらを向ける。
 * 飛び先はどちらも LINE 公式アカウント @528atbgq で同じ (実測で確認済み)。
 * 既定のスラッグを women-hp-cta にしているのは、広告用の meta-lp や、問い合わせ・浮くボタンの
 * 追跡リンクと混ざると、どこから来た友だち追加なのかが数えられなくなるため。
 * 浮くボタン (FloatingChatButton) だけは women-hp-float を引数で渡して分けている。
 */
export function useLineFollowUrl(defaultUrl: string = "https://yumesaku.tech/women/line/t/women-hp-cta"): string {
  const [url, setUrl] = useState<string>(defaultUrl);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("ref");
    const fromStorage = window.localStorage.getItem(STORAGE_KEY);
    setUrl(resolveLineFollowUrl(defaultUrl, fromUrl, fromStorage));
  }, [defaultUrl]);

  return url;
}
